module.exports = __webpack_public_path__ + "static/img/fanyu2.6eea1d6b.png";